import Vue from "vue";
import Vuex from "vuex";
import VuexPersistedstate from "vuex-persistedstate";

Vue.use(Vuex);

const initialState = () => ({
  messages: [],
});

export default new Vuex.Store({
  state: initialState,
  mutations: {
    ADD_MESSAGE(state, message) {
      state.messages.push(message);
    },
    REMOVE_MESSAGE(state, message) {
      state.messages = state.messages.filter((m) => m !== message);
    },
    INITIAL_STATE(state) {
      state.messages = initialState().messages;
    },
  },
  getters: {
    onlySenderMessages: (state) => state.messages.filter((m) => !m.reply),
  },
  actions: {
    createMessage({ commit }, message) {
      const now = new Date();

      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');

      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');

      const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
      const weekday = weekdays[now.getDay()];

      commit("ADD_MESSAGE", {
        reply: message.reply || false,
        content: message.content,
        createDate: `${year}年${month}月${day}日(${weekday})`,
        createTime: `${hours}:${minutes}`,
      });
    },
  },
  plugins: [
    new VuexPersistedstate({
      key: "vuex-chatbox",
      paths: ["messages"],
    }),
  ],
});
